<template>
	<a href class="btn-like" @click.prevent="click">
		<i class="fa fa-thumbs-o-up"></i>
		赞 {{count}}
	</a>
</template>

<script>
export default {
	name: "Like",
	props: ["refId", "refType", "init-num"],
	data() {
		return {
			count: this.initNum || 0
		};
	},
	methods: {
		click() {
			let user = this.$store.getters.user;
			if (!user) {
				return this.util.$emit("login")
			}

			this.$message.closeAll()
			this.axios
				.get(this.axios.apiGateway + "follow/like", {
					params: {
						token: user.token,
						refType: this.refType,
						refId: this.refId
					}
				})
				.then(res => {
					if (res.data.errcode) {
						this.$message.error(res.data.errmsg)
					} else {
						this.count = res.data.num
						if (res.data.status) {
							this.$message.success('点赞成功！')
						} else {
							this.$message.info('取消点赞！')
						}
					}
				})
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Like.vue